import React, { useEffect, useState } from 'react'
import { Button, message, Modal, Skeleton, Table } from 'antd'
import ApiV1 from 'api'
import Api from 'api/apiv2'
import { Can } from 'permissions'
import { config } from 'configs'

const columns = [
  {
    title: 'Donor Name',
    dataIndex: 'DonorName',
  },
  {
    title: 'Amount',
    dataIndex: 'Amount',
  },
]

const SendRemindersModal = ({ id, visible, onClose }) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [data, setData] = useState()
  const [loading, setLoading] = useState(true)

  const formateData = (values) => {
    const formatedData = values.map((item, index) => ({ ...item, key: index }))
    setData(formatedData)
  }

  useEffect(() => {
    setLoading(true)
    Api.get(`/admin/fundraisers/${id}/pledgers`)
      .then((res) => {
        if (res.data) formateData(res.data)
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
        message.error('An Error Occured')
      })
  }, [id, visible])

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys)
  }

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  }

  const onFinish = (type) => {
    const payload = data
      .filter((item) => selectedRowKeys.includes(item.key))
      .map((item) => ({
        Id: item.PledgeId,
      }))
    ApiV1.post(`/pledge/reminder/fundraiser`, { data: payload, type })
      .then(() => {
        message.success('Reminders sent Successfully')
        setSelectedRowKeys([])
        onClose()
      })
      .catch((error) => {
        console.log('error', error)
        message.error('An Error Occured')
      })
  }

  return (
    <Modal
      centered
      title="Send Pledge Reminders"
      open={visible}
      onCancel={onClose}
      footer={[]}
    >
      <Skeleton loading={loading} active paragraph={{ rows: 12 }}>
        <Table
          rowSelection={rowSelection}
          columns={columns}
          dataSource={data}
        />
        <div className="t-flex t-justify-end t-items-center t-space-x-2">
          <Can
            I={config.actions.edit}
            a={config.components.fundraiser}
            passThrough
          >
            {(allowed) => (
              <>
                <Button onClick={() => onFinish('Sms')} disabled={!allowed}>
                  Send SMS
                </Button>
                <Button onClick={() => onFinish('Email')} disabled={!allowed}>
                  Send Email
                </Button>
              </>
            )}
          </Can>
        </div>
      </Skeleton>
    </Modal>
  )
}

export { SendRemindersModal }
